export default __webpack_public_path__ + "images/card-logo-mastercard.f3efa681011e9acbf03ce2df04142c7c.png";